import React from 'react';
import 'babel-polyfill';
import 'whatwg-fetch';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { ErrorBoundary, lightColorPalette } from '@pearsontechnology/aero-components-learnspace';
import { ThemeProvider } from 'styled-components';
import { handleNewRelicInitBasedOnCookiePreference } from './cookies/NewRelic';
import App from './App';
import './index.css';
import registerPluginServices from './services/registerPluginServices';
import ToastContainer from './components/ToastContainer';
import OverlayContainer from './components/OverlayContainer';
import { handleFullStoryInitBasedOnCookiePreference } from './cookies/FullStory';
import { loadPendoScript } from './cookies/Pendo';

handleFullStoryInitBasedOnCookiePreference();
handleNewRelicInitBasedOnCookiePreference();
loadPendoScript();

ReactDOM.render(
  <IntlProvider locale="en">
    <ThemeProvider theme={{ ...lightColorPalette, themeId: 'light' }}>
      <ErrorBoundary>
        <OverlayContainer>
          <ToastContainer>
            <App />
          </ToastContainer>
        </OverlayContainer>
      </ErrorBoundary>
    </ThemeProvider>
  </IntlProvider>,
  document.getElementById('root')
);

// Register the plugin services
registerPluginServices();
